<label class="text-white f12">{{ label }}</label>
<div class="w-100 position-relative d-flex justify-content-center">
    @for (p of arr; track p) {
        <div tabindex="0" (focus)="setPin(pinEl)" class="input-pin rounded-top d-flex justify-content-center align-items-center text-center" [class.border-primary]="p < formControl.value.length">
            @if (formControl.value[p]) {
                <span>{{ obsecure === true? '•' : formControl.value[p] }}</span>
            }
        </div>
    }

    <ion-input 
        type="tel" 
        maxlength="6"
        pattern="[0-9]*" 
        autocomplete="off"
        inputmode="numeric" 
        class="pin-hidden position-absolute input-pin-master p-0 m-0" 
        [class.is-invalid]="errorMsg !== ''" 
        [value]="value" 
        (ionChange)="validatePin()" 
        (input)="input($event.target)" 
        #pinEl 
    />
</div>

@if (errorMsg) {
    <label class="is-invalid">{{ errorMsg }}</label>
}
